<template>
  <modal :modal-key="'service_promotion'"
         :class-style="'modal--welcomeback modal--zero-balance'" @close="goToPostGameModal">
        <template slot="header">
          <br>
          <img class="pinicon" src="static/images/envelope_icon.svg" alt="">
        </template>
        <template slot="body">
          <h2 class="modal_sub">{{ getTranslations.home_modals_service_promotion_keep_playing }}
          </h2>
        </template>
        <template slot="footer">
          <button class="btn2 btn2_modal btn2--std btn2--small" @click.prevent="goToRedirectUrl()">{{ getTranslations.home_modals_service_promotion_click_here }}</button>
        </template>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import PostGame from '@/components/home/modals/PostGame';

export default {
  name: 'servicePromotion',
  components: {
    Modal,
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    goToRedirectUrl() {
      window.location.href = `${this.getTranslations.home_modals_service_promotion_redirection_url}?refUrl=crossPromotion_${window.location.hostname}`;
    },
    goToPostGameModal() {
      this.storeModalForHomePage(PostGame);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ServicePromotion.vue